import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";


export default class Department extends ModelEntity {

    public name         : string
    public users        : number    // total users?



    constructor(data:any) {
        super(data['id'], EntityType.DEPARTMENT)

        this.name          = data['name']
        this.users         = data['users'] || 0


    }

}
